import { inject, Pipe, PipeTransform } from '@angular/core';
import { SNILS_MASK_SETTINGS } from '@bazis/configuration.service';
import { NgxMaskService } from 'ngx-mask';

/**
 * SnilsPipe formats a SNILS number using the configured mask.
 *
 * It uses `NgxMaskService` and `SNILS_MASK_SETTINGS.mask` from
 * `configuration.service.ts`. If no pattern or value is provided,
 * the original value is returned.
 *
 * Template usage:
 *```html
 *   @if (person?.snils as snils) {
 *       <span>{{ snils | snils }}</span>
 *   }
 * ```
 */
@Pipe({
    name: 'snils',
    standalone: true,
})
export class SnilsPipe implements PipeTransform {
    protected maskService = inject(NgxMaskService);

    /**
     * Format SNILS number using the configured mask.
     *
     * @param value Raw SNILS string.
     * @param pattern Optional mask pattern. Defaults to `SNILS_MASK_SETTINGS.mask`.
     * @returns Formatted SNILS string or original value when not applicable.
     */
    transform(value: string, pattern = SNILS_MASK_SETTINGS?.mask): string {
        if (!pattern || !value) return value;
        return this.maskService.applyMask(value, pattern);
    }
}
